module.exports = __webpack_public_path__ + "img/P150T_weapon_102.e8d720e9.png";